/** @format */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from "@material-ui/lab";
import Resume from "../../settings/resume.json";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSocialLinks } from "../../action/notesActions";
import { getObject } from "../../utils/getName";

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: "absolute",
    top: theme.spacing(6),
    right: theme.spacing(6),
  },
  iconColor: {
    color: theme.palette.foreground.default,
  },
}));

export const SpeedDials = () => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const dispatch = useDispatch();
  const social = useSelector((state) => state.SocialLinks);
  const { loadingsocial, error: socialerror, socialLinks } = social;

  useEffect(() => {
    // get();
    dispatch(getSocialLinks());
  }, [dispatch]);

  // const actionIcons = Resume.basics.profiles.map((action) => (
  //   <SpeedDialAction
  //     key={action.network.toLowerCase()}
  //     icon={<i className={`${action.x_icon} ${classes.iconColor}`}></i>}
  //     tooltipTitle={action.network}
  //     onClick={handleClose}
  //     href={action.url}
  //     target="_blank"
  //     rel="noopener noreferrer"
  //     underline="none"
  //     color="inherit"
  //   />
  // ));

  return (
    <>
      <SpeedDial
        ariaLabel="SpeedDial"
        className={classes.speedDial}
        hidden={false}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction="down"
      >
        {getObject(socialLinks, "email")?.status && (
          <SpeedDialAction
            key={"email"}
            icon={<i className={`fab fa-google ${classes.iconColor}`}></i>}
            tooltipTitle={"Email"}
            onClick={handleClose}
            href={`mailto:${
              getObject(socialLinks, "email")?.link
            }?subject=subject text`}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "linkedin")?.status && (
          <SpeedDialAction
            key={"LinkedIn"}
            icon={<i className={`fab fa-linkedin-in ${classes.iconColor}`}></i>}
            tooltipTitle={"LinkedIn"}
            onClick={handleClose}
            href={getObject(socialLinks, "linkedin")?.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "github")?.status && (
          <SpeedDialAction
            key={"github"}
            icon={<i className={`fab fa-github ${classes.iconColor}`}></i>}
            tooltipTitle={"GitHub"}
            onClick={handleClose}
            href={getObject(socialLinks, "github")?.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "telegram")?.status && (
          <SpeedDialAction
            key={"telegram"}
            icon={<i className={`fab fa-telegram ${classes.iconColor}`}></i>}
            tooltipTitle={"Telegram"}
            onClick={handleClose}
            // href={socialLinks?.telegram}
            href={getObject(socialLinks, "telegram")?.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "phone")?.status && (
          <SpeedDialAction
            key={"phone"}
            icon={<i className={`fas fa-phone ${classes.iconColor}`}></i>}
            tooltipTitle={"phone"}
            onClick={handleClose}
            href={`tel:${getObject(socialLinks, "phone")?.link}`}
            // href={socialLinks?.phoneNo}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "whatsApp")?.status && (
          <SpeedDialAction
            key={"whatsApp"}
            icon={<i className={`fab fa-whatsapp ${classes.iconColor}`}></i>}
            tooltipTitle={"whatsApp"}
            onClick={handleClose}
            href={getObject(socialLinks, "whatsApp")?.link}
            // href={socialLinks?.whatsApp}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
        {getObject(socialLinks, "web1")?.status && (
          <SpeedDialAction
            key={"Other Website"}
            icon={<i className={`fa fa-globe ${classes.iconColor}`}></i>}
            tooltipTitle={"Other Website"}
            onClick={handleClose}
            href={getObject(socialLinks, "web1")?.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
          />
        )}
      </SpeedDial>
    </>
  );
};
